import { useState } from 'preact/hooks'

/**
 * @param {*} inputs
 *
 * inputs : {
 *  [key: string] : any
 * }
 *
 * @returns
 */
export const useFormInput = (inputs, dataTypes) => {
  const [formInputs, setFormInputs] = useState(() => {
    const keys = Object.keys(inputs)
    return keys.reduce((acc, key) => {
      acc[key] = {
        key,
        value: inputs[key]
      }
      return acc
    }, {})
  })

  const handleUseTypes = (name, value) => {
    switch (dataTypes[name]) {
      case 'string': {
        return value
      }
      case 'number': {
        return parseInt(value)
      }
      case 'float': {
        return parseFloat(value)
      }
      case 'boolean': {
        return value === true || value === 'true'
      }
    }
  }

  const handleOnChange = (event) => {
    const input = event.currentTarget || event.target
    const name = input.name
    const value = dataTypes ? handleUseTypes(name, input.value) : input.value

    setFormInputs((i) => ({
      ...i,
      [name]: {
        ...i[name],
        value
      }
    }))
  }

  return { formInputs, handleOnChange }
}
